import React, { useEffect, useState } from "react";
import { Loader2 } from "lucide-react";
import api, { formatApiError } from "../lib/api";

const STATUSURI = ["Noua", "Proiect-ok1", "Proiect-ok2", "Start-ok", "Cadre-ok", "Livrare-S1", "Start-S1", "Orificii-ok",
  "Slefuire-ok", "Vopsire-ok", "Feronerie-ok", "Vitraj-ok", "Executat-ok", "Livrat-ok", "Suspendata", "Anulata"];
const fmt = (n) => Number(n || 0).toLocaleString("ro-RO", { maximumFractionDigits: 0 });

export const ProductieStatusAchizitie = () => {
  const [status, setStatus] = useState("Noua");
  const [data, setData] = useState(null);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    setError("");
    api.get("/api/productie/status-achizitie", { params: { status } })
      .then(({ data }) => setData(data))
      .catch((e) => { setData(null); setError(formatApiError(e.response?.data?.detail) || "Eroare la incarcare"); })
      .finally(() => setLoading(false));
  }, [status]);

  return (
    <div data-testid="productie-status-achizitie" className="space-y-4 pt-4 border-t border-slate-200">
      <p className="text-sm text-slate-500">Comenzi achizitie pe status (furnizor A AIG, comenzi vanzare de la 304053, stare curenta, fara filtru de data).</p>
      <div className="rounded border border-slate-200 bg-white p-4 flex flex-wrap items-end gap-3">
        <label className="text-xs font-medium text-slate-600">Status
          <select value={status} onChange={(e) => setStatus(e.target.value)} data-testid="productie-status-select"
            className="mt-1 block h-9 px-3 rounded border border-slate-300 text-sm bg-white">
            {STATUSURI.map((s) => <option key={s} value={s}>{s}</option>)}
          </select>
        </label>
        {loading ? <Loader2 size={16} className="animate-spin text-slate-400" data-testid="productie-status-loading" /> : null}
      </div>
      {error ? <div className="rounded border border-red-200 bg-red-50 p-4 text-sm text-red-700" data-testid="productie-status-error">{error}</div> : null}
      {data ? (
        <>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div className="rounded border border-slate-200 bg-white p-5 text-center" data-testid="productie-status-card-nr">
              <div className="text-3xl font-bold text-slate-800" data-testid="productie-status-nr-comenzi">{fmt(data.nr_comenzi)}</div>
              <div className="mt-1 text-xs text-slate-500">Nr comenzi</div>
            </div>
            <div className="rounded border border-slate-200 bg-white p-5 text-center" data-testid="productie-status-card-valoare">
              <div className="text-3xl font-bold text-slate-800" data-testid="productie-status-valoare">{fmt(data.valoare_eur)}</div>
              <div className="mt-1 text-xs text-slate-500">Valoare EUR (fara TVA)</div>
            </div>
          </div>
          <div className="rounded border border-slate-200 bg-white overflow-x-auto">
            <table className="w-full text-sm" data-testid="productie-status-table">
              <thead className="bg-slate-50 text-xs text-slate-600">
                <tr><th className="px-3 py-2 text-left">Nr Com.Vanz</th><th className="px-3 py-2 text-left">Data</th><th className="px-3 py-2 text-right">Valoare</th></tr>
              </thead>
              <tbody>
                {data.comenzi.map((c) => (
                  <tr key={c.nr} className="border-t border-slate-100" data-testid={`productie-status-row-${c.nr}`}>
                    <td className="px-3 py-2">{c.nr}</td><td className="px-3 py-2">{c.data}</td><td className="px-3 py-2 text-right">{fmt(c.valoare)}</td>
                  </tr>
                ))}
                {!data.comenzi.length ? <tr><td colSpan={3} className="px-3 py-4 text-center text-slate-400" data-testid="productie-status-empty">Nicio comanda</td></tr> : null}
              </tbody>
            </table>
          </div>
        </>
      ) : null}
    </div>
  );
};
